import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Container, Image, Spinner, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { isLoggin } from '../service/LoginService';
import RegistOrLogin from './RegistOrLogin';
import DynamicDialog from './DynamicDialog';
import UserMark from './UserMark';
import { LoginInfo } from '../App';

const AccountDelete = () => {
	async function getTerms(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/terms").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function checkout(plan){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/checkout/subscribe/"+plan).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const {t,i18n} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [checkoutProcess,setCheckoutProcess] = useState(false)
    const [showDialog,setShowDialog] = useState(false)
    const [title,setTitle] = useState("")
    const [message,setMessage] = useState("")
    function dialog(title,message){
        setTitle(title)
        setMessage(message)
        setShowDialog(true)
    }

	useEffect(() => {
		document.querySelector("title").textContent = "会社概要 - アワート合同会社"
	},[location.pathname])

    function checkoutProcessHandler(plan){
        setCheckoutProcess(true)
        isLoggin().then(r => {
            if(r.result){
                checkout(plan).then(r => {
                    if(r.result){
                        window.location.href = r.data.url
                    } else {
                        dialog("",r.errors)
                        setCheckoutProcess(false)
                    }
                })
            } else {
                dialog(t("common.loginToContinue"),<RegistOrLogin />)
                setCheckoutProcess(false)
            }
        })
    }

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Category />
        <Dialog show={showDialog} title="" message={message} handleClose={() => setShowDialog(false)} />
        <Container>
            <Container className='text-center'>
                <img src='/img/ourt_logo_dashed.png' height={70} />
            </Container>
            <h3 style={{fontWeight:"normal",fontFamily:"Meityo UI"}} className='mb-3 mt-3'>アワートAIアカウント、関連データ削除申請</h3>
            利用者が希望する場合、アカウントの削除や関連するデータの削除を申請することができます。<br />
            【アカウントの削除】または【登録データの一部訂正、削除】をメールタイトルに記載し<br />訂正するデータと訂正する内容を送信してください。<br />
            <Table striped>
                <tbody>
                    <tr><th>削除、訂正できる情報</th><td>ユーザー名、メールアドレス、電話番号、氏名、生年月日、性別、誕生日、身分証データ、<br />
                        支払情報、外部アカウント連携情報を含む認証情報、サービスに投稿した情報</td></tr>
                    <tr><th>削除するにはアカウントの削除が必要になる情報</th><td>ユーザー名、メールアドレス、生年月日、性別</td></tr>
                    <tr><th>アカウントの削除申請から完全にデータが削除されるまでの期間</th><td>1年</td></tr>
                    <tr><th>送信先</th><td>contact＠ourt-ai.work</td></tr>
                </tbody>
            </Table>
        </Container>
    </div>
    )
}

export default AccountDelete;
